/** userType → 账户类型文案（2 不显示） */
const TYPE_LABEL = {
  1: '杰宜斯投顾账户',
  3: '杰宜斯资金账户',
  4: 'CTP直连账户',
  5: '第三方账户',
};

export function groupingAccountTypeLabel(raw) {
  const ut = Number(raw && raw.userType);
  if (ut === 2) return '';
  return TYPE_LABEL[ut] || '—';
}

/** 绑定弹窗行：补全 userTypeName，杰宜斯类经纪商显示 - */
export function applyGroupingRowDisplay(raw) {
  const ut = Number(raw && raw.userType);
  return {
    ...raw,
    userTypeName: groupingAccountTypeLabel(raw),
    ...(ut >= 1 && ut <= 3
      ? { brokerName: '-', serverManageName: '-' }
      : {}),
  };
}



// WEBPACK FOOTER //
// ./src/view/client/grouping/groupingAccountType.js